module.exports = __webpack_public_path__ + "img/KinokoTable16.0626aa5b.jpg";